export const bespokeTenants = {
    mortangProd: '50fadc10-ec37-4634-81d8-c1d90ba52cfa',
    apcoaProd: 'b193c095-d699-4edc-8eef-8f4a80350289',
    apcoaSandbox: '1a42cfc1-2b4d-48e1-b224-9638f159aa41',
    euroIncassoProd: 'f7a160b4-feb7-4123-ac6e-ebe863f3f56e',
    euroIncassoSandbox: '34dc0bda-5df3-4384-8295-779196dd3b09',
    nunaLawProd: '927712af-bb7b-4b6b-8e0a-3c323436df16',
    eosProd: '4284cfac-31b9-4d8a-bd6e-e0b833e9936a',
};
//# sourceMappingURL=index.js.map